<template>
	<LazyLoadWrapper>
		<div class="w-full" :class="blok.background_color || 'bg-primary'">
			<div
				class="main-wrapper lg:px-4 px-8 flex md:flex-row flex-col mt-14 py-14 gap-8"
			>
				<div class="flex w-full md:w-7/12 flex-col gap-4">
					<h3 class="text-3xl" :class="blok.text_color || 'text-white'">
						{{ blok.heading }}
					</h3>
					<span class="text-lg" :class="blok.text_color || 'text-gray-dark'">{{
						blok.supporting_text
					}}</span>
				</div>
				<div class="flex w-full md:w-5/12 flex-col gap-4">
					<div class="flex md:gap-1 gap-3 justify-start items-center">
						<StoryblokComponent
							v-for="email in blok.email"
							:key="email._uid"
							:blok="email"
							class="w-7/12"
						/>
						<StoryblokComponent
							v-for="call_to_action in blok.call_to_action"
							:key="call_to_action._uid"
							:blok="call_to_action"
							class="w-5/12"
						/>
					</div>
					<StoryblokComponent
						v-for="privacy_policy in blok.privacy_policy"
						:key="privacy_policy._uid"
						:blok="privacy_policy"
						class="text-sm"
						:class="blok.text_color || 'text-gray-dark'"
					/>
				</div>
			</div>
		</div>
	</LazyLoadWrapper>
</template>

<script setup lang="ts">
import type { BlokNewsletter } from "~/types/storyblok/storyblok";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";

interface Props {
	blok: BlokNewsletter;
}
const { blok } = defineProps<Props>();
</script>
